export default function Privacy(){
  return (
    <main role="main">
      <section className="section">
        <h1 className="h1">Privacy Policy</h1>
        <p className="muted">We respect your privacy. This page outlines how FieldShare processes personal data.</p>
        <h2 className="h2">Summary</h2>
        <ul>
          <li>Authentication is provided via Google. We store your account email for ownership and audit trails.</li>
          <li>Uploads are scanned and may be processed for previews (images/video transcodes) on secure infrastructure.</li>
          <li>We never sell personal data. You can request deletion at any time via support.</li>
        </ul>
        <h2 className="h2">Contact</h2>
        <p>privacy@your-domain.tld</p>
      </section>
    </main>
  )
}

